import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root'
})
export class DisciplineService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getDisciplines() {
    return this.http.get<any>(`${environment.apiBaseUrl}/disciplines`);
  }

  getDiscipline(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/disciplines?filters[id][$eq]=${id}&populate=*`);
  }

  getVisibleDisciplines() {
    return this.http.get<any>(`${environment.apiBaseUrl}/disciplines?filters[getoond_in_overzicht][$eq]=true&populate=*`);
  }

  populateDiscipline(data:any) {
    let disc = data;
    disc.id = data.id;
    disc.pic = this.mediaService.getMediaItemUrl(disc.foto);
    disc.banner_image = this.mediaService.getMediaItemUrl(disc.banner_image, null);

    return disc;
  }
}
